import { IconBack } from './Back';
import { IconClose } from './Close';
import { IconCopyCode } from './CopyCode';
import { IconCross } from './Cross';
import { IconCheckmark } from './Checkmark';
import { IconEdit } from './Edit';
import { IconFilter } from './Filter';
import { IconIndeterminate } from './Indeterminate';
import { IconLogout } from './Logout';
import { IconMode } from './Mode';
import { IconPlus } from './Plus';
import { IconSandbox } from './Sandbox';
import { IconSort } from './Sort';
import { IconSend } from './Send';
import { IconTableEdit } from './TableEdit';
import { IconTick } from './Tick';
import { IconTrash } from './Trash';
import { IconCommand } from './Command';
import { IconSwap } from './Swap';
import { IconPlay } from './Play';
export const IconAction = {
    Back: IconBack,
    Close: IconClose,
    CopyCode: IconCopyCode,
    Cross: IconCross,
    Checkmark: IconCheckmark,
    Logout: IconLogout,
    Mode: IconMode,
    Sort: IconSort,
    Send: IconSend,
    Plus: IconPlus,
    Sandbox: IconSandbox,
    Tick: IconTick,
    Trash: IconTrash,
    Indeterminate: IconIndeterminate,
    Edit: IconEdit,
    Command: IconCommand,
    Filter: IconFilter,
    TableEdit: IconTableEdit,
    Swap: IconSwap,
    Play: IconPlay,
};
//# sourceMappingURL=index.js.map